import EventListingSection from "../../components/Events/EventListingSection";
import Page from "../../components/Page";
import LeaderBoardComp from "../../components/leaderboardComp/LeaderBoardComp";
import "./LeaderBoardPage.scss";

const LeaderBoardPage = () => {

  return (
    <Page>
      <section className="leaderboard-page">
        <div className="container mt-4">
        <LeaderBoardComp />
        </div>
      </section>
    </Page>

  )


}

export default LeaderBoardPage;